// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumb_breadcrumb__78ukP","lastBreadcrumb":"Breadcrumb_lastBreadcrumb__eIagE","breadcrumbWrapper":"Breadcrumb_breadcrumbWrapper__-CoJr"};